import { isNil } from 'lodash';

import { LeaseAction, LeaseActionHistory, LeaseActionHistoryStatus } from './types';

export const LEASE_ACTION_HISTORY_CUSTOM_CONTACT_ID = 'Up2Rent';

export const getEndLeaseActionHistoryToProcess = (leaseActionHistories: LeaseActionHistory[], leaseId: string) =>
  leaseActionHistories.find(
    (leaseActionHistory) =>
      leaseActionHistory.leaseId === leaseId &&
      leaseActionHistory.action === LeaseAction.END_LEASE &&
      !isNil(leaseActionHistory.totalAmount) &&
      leaseActionHistory.totalAmount !== 0 &&
      leaseActionHistory.status === LeaseActionHistoryStatus.TO_PROCESS
  );

export const getRecordedEndLeaseAction = (leaseActionHistories: LeaseActionHistory[]) =>
  leaseActionHistories.find((leaseActionHistory) => leaseActionHistory.action === LeaseAction.END_LEASE);

export const getOwnerVisibleLeaseActionHistories = (leaseActionHistories: LeaseActionHistory[]): LeaseActionHistory[] =>
  leaseActionHistories.filter((leaseActionHistory) => leaseActionHistory.action !== LeaseAction.CUSTOM);
